import React from 'react';
import EventTempFormContainer from '../../../../Containers/AdminContainer/EventTemplateScheduler/EventTempForm';
const EventTempFormScreen = () => {
  return <EventTempFormContainer />;
};

export default EventTempFormScreen;
